<template>
  <div class="countdown-container">
    <img class="logo" src="https://static-jp.theckb.com/static-asset/client/sellerstation/transfer_logo.png" alt="">

    <div style="width: 722px;" class="introduce_container">
      <div class="title">
        SellerStation × THE CKB（直行便）について
      </div>
      <div class="tips">THE CKB（直行便）とSellerStationは、いずれもSNIFF GROUPが運営するサービスです。</div>
      <div class="flex">
        <div class="introduce" style="margin-right: 24px;">
          <img class="introduce_logo" src="https://static-jp.theckb.com/static-asset/client/sellerstation/live_ckb.png"
            alt="">
          <div>サプライチェーン・物流・フルフィルメントに関するサービスを提供しています。</div>
        </div>
        <div class="introduce">
          <img class="introduce_logo"
            src="https://static-jp.theckb.com/static-asset/client/sellerstation/live_sellestation.png" alt="">
          <div>ブランド育成や売上拡大を支援する各種サービスを提供しています。</div>
        </div>
      </div>

      <div class="bTips">※ご注文情報やアカウントは一元管理されておりますので、安心してご利用いただけます。</div>
    </div>
    <div class="loader">
      <!-- 中间倒计时数字 -->
      <div class="number">{{ count }}</div>
      <!-- 外圈小球 -->
      <div class="dots-wrapper">
        <div v-for="(i, index) in 8" :key="index" class="dot" :class="{ 'active': index === currentIndex }"
          :style="{ '--angle': `${index * 45}deg` }"></div>
      </div>
    </div>
    <div class="loadingTip">Loading...</div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue';

import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
const route = useRoute()
const router = useRouter()
const store = useStore()

onMounted(async () => {

})

const count = ref(5);
const currentIndex = ref(0);
let timer5s = null;
let timerRotate = null;

onMounted(async () => {
  if (route.query.token && route.query.curShop) {
    await store.dispatch('route/changeToken', route.query.token)
    await store.dispatch('route/changeShop', route.query.curShop)

    // 移除 URL 中的敏感参数
    const query = { ...route.query }
    delete query.token
    delete query.curShop
    // 替换当前路由，不刷新页面但更新 URL
    router.replace({ query })
  }

  // // 1. 每秒数字减 1
  // timer5s = setInterval(() => {
  //   if (count.value > 1) {
  //     count.value--;
  //   } else {
  //     count.value = 5
  //   }
  // }, 1000);

  // // 2. 高亮位置轮转 (每 100ms 移动一个位置，创造旋转感)
  // timerRotate = setInterval(() => {
  //   currentIndex.value = (currentIndex.value + 1) % 8;
  // }, 250);
});

watch(() => route.query, () => {
  // debugger
  if (route.query.redirect && !route.query.token) {
    // 1. 每秒数字减 1
    timer5s = setInterval(() => {
      if (count.value > 1) {
        count.value--;
      } else {
        clearInterval(timer5s)
        location.href = route.query.redirect;
        localStorage.setItem(
          '_reload_page_',
          Math.random().toString().slice(2)
        )
      }
    }, 1000);

    // 2. 高亮位置轮转 (每 100ms 移动一个位置，创造旋转感)
    timerRotate = setInterval(() => {
      currentIndex.value = (currentIndex.value + 1) % 8;
    }, 250);
  }
}, {
  immediate: true,
  deep: true
})

onUnmounted(() => {
  clearInterval(timer5s);
  clearInterval(timerRotate);
});
</script>

<style scoped>
.countdown-container {
  background: #000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .logo {
    width: 1029px;
    margin-bottom: 30px;
  }

  .introduce_container {
    .introduce {
      width: 336px;
      line-height: 22px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.65);

      .introduce_logo {
        height: 20px;
      }
    }

    .title {
      font-size: 14px;
      text-align: left;
      color: rgba(255, 255, 255, 0.88);
      line-height: 22px;
      font-weight: 700;
      margin-bottom: 4px;
    }

    .tips {
      color: rgba(255, 255, 255, 0.65);
      line-height: 22px;
      font-size: 14px;
      margin-bottom: 24px;
    }

    .bTips {
      width: 722px;
      margin-top: 16px;
      color: #FFC53D;
      text-align: left;
      line-height: 22px;
    }
  }
}

.loadingTip {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-top: 50px;
}

.loader {
  margin-top: 64px;
  position: relative;
  width: 58px;
  height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.number {
  color: white;
  font-size: 26px;
  font-weight: bold;
  font-family: Arial, sans-serif;
}

.dots-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
}

.dot {
  position: absolute;
  top: 50%;
  left: 50%;
  /* 初始状态：小、红、半透明 */
  width: 6px;
  height: 6px;
  background-color: #ff3b5c;
  border-radius: 50%;

  /* 关键：使用 transition 让“缩小”和“变红”的过程变得平滑 */
  transition: all 0.5s ease;

  /* 圆周排列 */
  transform: translate(-50%, -50%) rotate(var(--angle)) translateY(-45px);
}

/* 高亮状态：大、青、全显 */
.dot.active {
  width: 30px;
  height: 30px;
  background-color: #4df2f2;
  /* opacity: 1; */
  /* 只有变大时需要瞬间反应，所以这里用较短的 transition 或者单独设置 */
  transition: all 0.5s ease;
  z-index: 2;
}
</style>
